import { render, staticRenderFns } from "./AdminInstitutionsSearch.vue?vue&type=template&id=7842be20&"
import script from "./AdminInstitutionsSearch.vue?vue&type=script&lang=js&"
export * from "./AdminInstitutionsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports